import LoadingComponent from '@/pages/components/loadingComponent'
import Loadable from 'react-loadable'

export default [
  {
    component: Loadable({
      loader: () => import('@/pages/waitingVerified/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/waitingVerified',
    meta: {
      title: '待认证'
    }
  }
]
